"use strict";

(function (skyward, $, undefined)
{
    skyward.reporting = skyward.reporting || {};
    skyward.reporting.multiColumnSection = skyward.reporting.multiColumnSection || {};

    skyward.reporting.multiColumnSection.init = function (data)
    {
        //data.columnWidth;
        //data.columnSpacing;
        //data.applyColumnsToDataLinesOnly;
        //data.balanceColumns;
        //data.columnDirection;
        //data.defaultWidth;
        //data.callBack();
        //data.currentSectionDisplayOnSingleLine

        var ok = function ()
        {
            var columnWidthVal = Number(columWidth.val());
            columnWidthVal = columnWidthVal === "" ? data.defaultWidth : +columnWidthVal;
            var columnSpacingVal = Number(columnSpacing.val());
            columnSpacingVal = columnSpacingVal === "" ? 0 : +columnSpacingVal;
            var unusableWidth = (data.defaultWidth - columnWidthVal) * 72;
            var newData =
            {
                columnWidth: columnWidthVal,
                columnSpacing: columnSpacingVal,
                applyColumnsToDataLinesOnly: skyward.radioButtonGroup.getValue(applyColumnsToDataLinesOnly).toLowerCase() === "true",
                balanceColumns: balanceColumns.prop("checked"),
                columnDirection: skyward.radioButtonGroup.getValue(columnDirection),
                unusableAreaBox: skyward.reporting.multiColumnSection.generateUnusableAreaBox(unusableWidth)
            };
            data.callBack(newData);
            modalLayer.close();
        };

        var reset = function ()
        {
            columWidth.val(data.defaultWidth);
            columnSpacing.val(0);
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, "false");
            balanceColumns.prop("checked", false);
            skyward.radioButtonGroup.setValue(columnDirection, "Down");
        };

        var multiColumnSectionEditorHTML = $(".multiColumnSectionEditorTemplate").html();

        var okButton = { text: "Save", icon: "Save", click: ok };
        var cancelButton = { text: "Cancel", icon: "Cancel", click: "close" };
        var resetButton = { text: "Reset", icon: "Undo", click: reset };
        var buttons = [resetButton, okButton, cancelButton];
        var modalLayer = skyward.modalLayer.showDialog("Multi-Column Section", multiColumnSectionEditorHTML, buttons, { closeOnClick: false });

        var multiColumnSectionEditor = modalLayer.content.children('.multiColumnSectionEditor');

        var columWidth = multiColumnSectionEditor.find(".columnWidth");
        var columnSpacing = multiColumnSectionEditor.find(".columnSpacing");
        var applyColumnsToDataLinesOnly = multiColumnSectionEditor.find(".applyColumnsToDataLinesOnly");
        var balanceColumns = multiColumnSectionEditor.find(".balanceColumns");
        var columnDirection = multiColumnSectionEditor.find(".columnDirection");
        var contentMessageArea = skyward.contentMessageArea.getContentMessageArea(multiColumnSectionEditor);

        skyward.controls.toggle(columWidth, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnSpacing, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(applyColumnsToDataLinesOnly, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(balanceColumns, !data.currentSectionDisplayOnSingleLine);
        skyward.controls.toggle(columnDirection, !data.currentSectionDisplayOnSingleLine);
        if (data.currentSectionDisplayOnSingleLine)
        {
            contentMessageArea.showInformation();
        }

        columWidth.val(data.columnWidth === "" ? data.defaultWidth : data.columnWidth);
        columnSpacing.val(data.columnSpacing || 0);
        balanceColumns.prop("checked", data.balanceColumns);
        if (data.applyColumnsToDataLinesOnly)
        {
            skyward.radioButtonGroup.setValue(applyColumnsToDataLinesOnly, data.applyColumnsToDataLinesOnly.toString());
        }
        if (data.columnDirection)
        {
            skyward.radioButtonGroup.setValue(columnDirection, data.columnDirection);
        }

        var checkForNegativeNumber = function (event)
        {
            var input = event.target;

            if (input.value < 0)
            {
                input.value = 0;
            }
        };

        var toggleBalanceBasedOnDirection = function (direction)
        {
            if (direction === "Across")
            {
                balanceColumns.prop("checked", false);
                balanceColumns.parent().hide();
            }
            else
            {
                balanceColumns.parent().show();
            }
        };

        toggleBalanceBasedOnDirection(skyward.radioButtonGroup.getValue(columnDirection));

        columWidth.on("change", checkForNegativeNumber);
        columnSpacing.on("change", checkForNegativeNumber);
        columnDirection.on("change", function (event)
        {
            toggleBalanceBasedOnDirection(event.target.value);
        });
    };

    skyward.reporting.multiColumnSection.generateUnusableAreaBox = function (unusableWidth)
    {
        return $("<div/>").addClass("unusableArea").css("width", unusableWidth + "pt");
    };

})(skyward || {}, window.jQuery);